/** External Chainz POS app (cashier client). */
export const POS_APP_URL =
  process.env.REACT_APP_POS_URL || "https://pos.chainzsolutions.com";

export const posLoginUrl = () => `${POS_APP_URL.replace(/\/$/, "")}/login`;
export const posHomeUrl = () => `${POS_APP_URL.replace(/\/$/, "")}/`;

export function redirectToPos(path = "/") {
  const base = POS_APP_URL.replace(/\/$/, "");
  const suffix = path.startsWith("/") ? path : `/${path}`;
  window.location.assign(`${base}${suffix === "/" ? "/" : suffix}`);
}
